import {
    initializeAgentPresence,
    disconnectAgentPresence,
} from 'shells/inbox/hooks/use-agent-presence';

import type {LicenseType} from 'nutshell-graphql-types';

// @ts-expect-error
import {refreshUser} from '../../user';

import {useGetSessionUser} from '../core/use-get-session-user';

export function useHandleLicenseToggle() {
    const {user} = useGetSessionUser();

    const handleLicenseChange = (input: {
        licenseState: {
            isEngagementOn?: boolean;
            isCrmOn?: boolean;
            isMarketingOn?: boolean;
        };
        licenseType: LicenseType;
        userId: string;
    }) => {
        if (user && user.id === input.userId) {
            refreshUser(input.userId);
            switch (input.licenseType) {
                case 'ENGAGEMENT':
                    if (!input.licenseState.isEngagementOn) {
                        initializeAgentPresence(true);
                    } else {
                        disconnectAgentPresence();
                    }
                    break;
                case 'CRM':
                    break;
                case 'MARKETING':
                    break;
                default:
                    break;
            }
        }
    };

    return {handleLicenseChange};
}
